import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import NamesCell from '~/glm/components/guest-list/cells/names-cell';
import PartyOfCell from '~/glm/components/guest-list/cells/party-of-cell';
import TextCell from '~/glm/components/guest-list/cells/text-cell.jsx';
import CheckboxCell from '~/glm/components/guest-list/cells/checkbox-cell.jsx';
import ContactInfoCell from '~/glm/components/guest-list/cells/contact-info-cell.jsx';
import RsvpsCell from '~/glm/components/guest-list/cells/rsvps-cell.jsx';
import MealsCell from '~/glm/components/guest-list/cells/meals-cell.jsx';
import AnalyticsStore from '~/glm/models/analytics-store';
import SelectionCellGroup from '~/glm/components/guest-list-table/cells/selection-cell-group';
import cellStyles from './guest-row.scss';
import styles from './row.scss';

@observer
class DisabledHouseholdRow extends Component {
  static propTypes = {
    event: PropTypes.instanceOf(GdsEventModel).isRequired,
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    trackMeal: PropTypes.func.isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore),
    usesQuestions: PropTypes.bool.isRequired,
  };

  invitedGuests = () => {
    const { event } = this.props;
    return this.household.invitedGuests(event.id);
  };

  get partyCount() {
    return this.invitedGuests().length;
  }

  get gift() {
    const { event } = this.props;
    return this.household.getGift(event.id);
  }

  renderSelectionCells = () => {
    const guests = this.invitedGuests();
    return <SelectionCellGroup group={guests} />;
  };

  render() {
    const { event, gdsUiState, trackMeal, analyticsStore, usesQuestions } = this.props;
    this.household = gdsUiState.selectedEvent.getPlaceholderHousehold();

    if (!this.household) return null;

    return (
      <div key={`household-row-${this.household.id}`} className={styles.householdRow}>
        {this.renderSelectionCells()}
        <NamesCell disabled guests={this.invitedGuests()} />
        <PartyOfCell disabled value={this.partyCount} />
        <ContactInfoCell household={this.household} />
        <RsvpsCell
          disabled
          gdsUiState={gdsUiState}
          invitations={this.household.guestInvitations(event.id)}
          guests={this.invitedGuests()}
        />
        {!usesQuestions && gdsUiState.selectedEvent && gdsUiState.selectedEvent.hasMeals() && (
          <MealsCell
            disabled
            mealQuestion={event.mealQuestion}
            trackMeal={trackMeal}
            gdsUiState={gdsUiState}
            analyticsStore={analyticsStore}
            invitations={this.household.guestInvitations(event.id)}
          />
        )}
        {gdsUiState.isColumnVisible('Notes') && (
          <TextCell disabled type="notes" value={this.household.coupleNote} className={cellStyles.notes} />
        )}
        {gdsUiState.isColumnVisible('Gift') && (
          <TextCell disabled type="gift" value={this.gift} className={cellStyles.gift} />
        )}
        {gdsUiState.isColumnVisible('Thank You Sent') && (
          <CheckboxCell
            entity={this.household}
            checked={this.household.anyGuestThankYouSent(event.id)}
            id={this.household.id}
            className={cellStyles.thankYou}
            onClick={() => {}}
          />
        )}
      </div>
    );
  }
}

export default DisabledHouseholdRow;
